module.exports = __webpack_public_path__ + "static/img/SG.2d6f7c25.svg";